<script>
import Icon from "./Icon.vue";

export default {
  name: "Selector",
  components: {Icon},
  props: ['name', 'modelValue', 'data', 'disabled'],
  data(){
    return {
      isOpen: false
    }
  },
  methods: {
    getSelectedName(){
      return this.modelValue.name ?? 'Не выбрано'
    },
    getSelectedImage(){
      return this.modelValue.src ?? false
    },
    isSelected(){
      return Object.keys(this.modelValue).length > 0
    },
    change(item){
      this.isOpen = false
      this.$emit('update:modelValue', item)
    },
    clickSelector(){
      if(!this.disabled){
        this.isOpen = !this.isOpen
      }
    },
    getItems(){
      return this.isSelected() ? this.data.filter((item) => this.modelValue.id !== item.id) : this.data
    }
  }
}
</script>

<template>
  <div :class="['selector', {'selector--open': isOpen, 'selector--select': isSelected(), 'selector--disabled': disabled}]" @click="clickSelector">
    <div class="selected-element">
      <div class="left">
        <div class="image">
          <img v-if="getSelectedImage()" :src="getSelectedImage()">
        </div>
        <div class="name" v-html="getSelectedName()"></div>
      </div>
      <div class="right">
        <Icon name="selector-arrow" class="arrow"/>
      </div>
    </div>
    <div class="selector-items">
      <label class="selector-item" v-for="item in getItems()" :key="'selector-'+item.id">
        <input
            type="radio"
            :name="name"
            :value="item.id"
            @change="change(item)"
            :disabled="disabled"
        >
        <div class="image">
          <img v-if="item.src" :src="item.src">
        </div>
        <div class="name" v-html="item.name"></div>
      </label>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import "/src/style/variable";

  .selector {
    overflow: hidden;
    border: 2px solid rgb(255, 112, 82);
    border-radius: 20px;
    font-family: $font-family;
    font-size: 24px;
    font-weight: 700;
    user-select: none;
    @media #{$media-575} {
      font-size: 18px;
      .selected-element {
        .name {
          width: 70%;
        }
      }
      .selector-items {
        .name {
          width: 90%;
        }
      }
    }
    &.selector--open {
      border-color: $color-white;
      box-shadow: 0px 8px 40px 0px rgba(0, 0, 0, 0.2);
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      .selector-items {
        display: flex;
        flex-direction: column;
      }
      .selected-element {
        border-bottom: 1px solid $color-blue-opacity-03;
      }
    }
    &.selector--select {
      border-color: transparent;
      .selected-element {
        color: $color-white;
        background-color: $color-blue;
        .right {
          .arrow {
            fill: $color-white;
            stroke: $color-white;
          }
        }
      }
    }
    &.selector--disabled {
      opacity: 0.5;
      .selected-element{
        background-color: $color-gray;
        color: $color-blue;
        .right {
          .arrow {
            display: none;
          }
        }
      }
    }
    .image {
      height: 70px;
      width: 70px;
      @media #{$media-575} {
        height: 35px;
        width: 35px;
      }
      img {
        max-height: 100%;
        width: 100%;
      }
    }
    .selector-item,
    .selected-element {
      font-weight: 600;
      padding: 20px 30px;
    }
    .selector-items {
      display: none;
      .selector-item {
        display: flex;
        gap: 20px;
        align-items: center;
        color: $color-blue;
        &:hover {
          background-color: $color-blue;
          color: $color-white;
        }
        input {
          display: none;
        }
      }
    }
    .selected-element {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        gap: 20px;
      }
      .right {
        .arrow {
          fill: $color-blue;
          stroke: $color-blue;
          width: 17px;
          height: 15px;
        }
      }
    }
  }
</style>